module.exports = __webpack_public_path__ + "img/QR_doc.5c0acc9d.png";